import { combineReducers } from 'redux-immutable'
import { Map, fromJS } from 'immutable';
import trailerReducer from './trailer';
import userbarReducer from './userbar';
import elementDisplayReducer from './elementDisplay';
import connectionReducer from './connection';



const INIT_STATE = Map();
const SUBSTATE_NAME = "ui";

const combinedReducer = combineReducers({
    trailer: trailerReducer,
    userbar: userbarReducer,
    elementDisplay: elementDisplayReducer,
    connection: connectionReducer
});

const uiReducer = (state = INIT_STATE, action) => {
    if(action == null) { 
        return state;
    }
    
    // const immutableState = fromJS(state)
    const immutableState = state
    const substate = immutableState.get(SUBSTATE_NAME, INIT_STATE)
    const new_substate = combinedReducer(substate, action);
    
    return immutableState.set(SUBSTATE_NAME, new_substate);
}

export default uiReducer;